import axios from 'axios';
import config from '../config';

export const upload = async ({
  date,
  uploadedFile,
  uploadedFilename,
}) => {
  const { dataUrl, dataApiKey } = config || {};
  return axios({
    url: `${dataUrl}/upload`,
    method: 'POST',
    data: {
      date,
      uploadedFile,
      uploadedFilename,
    },
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => resp.data);
};

export default { upload };
